import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { STUDIO, VIDEOS } from '../data/mock';
import { usePageMeta } from '../components/Layout';
import { Reveal, CloseCTA, PageHero, MarianaEmbed } from '../components/Shared';

export default function Schedule() {
  usePageMeta(
    'Weekly HIIT Class Schedule — Dallas',
    'PITFIT\u2019s live HIIT class schedule in Uptown Dallas. 45- and 60-minute non-stop classes Monday through Sunday. Reserve your spot — $15 first class for new clients.'
  );

  return (
    <>
      <PageHero
        tag="Live Weekly Schedule"
        title="This week in the PIT"
        sub="Non-stop 45- and 60-minute classes, coached start to finish. Real-time availability, straight from the studio's booking system."
        video={VIDEOS.classroom}
      />

      <section className="section-pad !pt-10">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <Reveal>
            <div className="flex flex-wrap items-center justify-between gap-3 mb-5">
              <div>
                <p className="mono-label mb-2">Live Schedule · Real-Time Availability</p>
                <h2 className="font-display font-bold text-2xl md:text-3xl text-white">Book straight from the live board.</h2>
              </div>
              <span className="font-mono-pf text-[11px] uppercase tracking-[0.12em] px-3 py-1.5 rounded-full" style={{ background: 'rgba(70,127,247,0.15)', color: 'var(--pf-brand2)', border: '1px solid rgba(125,167,255,0.35)' }}>
                Synced with the studio
              </span>
            </div>
            <MarianaEmbed testId="mariana-live-schedule" />
            <p className="text-muted-pf text-[13px] mt-3">
              Live times, spots and checkout are synced directly with the studio's booking system. Trouble loading? <Link to="/book" className="underline underline-offset-4" style={{ color: 'var(--pf-brand2)' }}>Book with the quick form</Link> instead.
            </p>
          </Reveal>

          <div className="glass-card mt-12 p-7 md:p-8 flex flex-col md:flex-row md:items-center gap-6 justify-between" style={{ borderColor: 'rgba(125,167,255,0.3)' }}>
            <div>
              <h3 className="font-display font-semibold text-white text-xl">First time? It’s just $15.</h3>
              <p className="text-muted-pf text-[15px] mt-2">Pick any class on the live board. Arrive 15 minutes early — we'll handle the rest.</p>
            </div>
            <Link to="/book" className="btn-primary shrink-0">Book a Class <ArrowRight size={16} /></Link>
          </div>

          <div className="mt-12 grid md:grid-cols-3 gap-5 text-[15px]">
            <div className="glass-card p-6">
              <p className="mono-label mb-3">Studio Hours</p>
              {STUDIO.hours.map((h) => (
                <p key={h.d} className="text-muted-pf"><span className="text-white font-medium">{h.d}:</span> {h.h}</p>
              ))}
            </div>
            <div className="glass-card p-6">
              <p className="mono-label mb-3">Waitlist</p>
              <p className="text-muted-pf">Full class? Join the waitlist right on the live board — spots open often, and you'll be notified the moment one does.</p>
            </div>
            <div className="glass-card p-6">
              <p className="mono-label mb-3">Parking</p>
              <p className="text-muted-pf">Free parking in the Travis Walk garage — the studio is inside the structure. <Link to="/hiit-workout/first-class" className="underline underline-offset-4" style={{ color: 'var(--pf-brand2)' }}>Details</Link></p>
            </div>
          </div>
        </div>
      </section>

      <CloseCTA />
    </>
  );
}
